/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { baricon1, user06, logoVoxel } from './imagepath';
import ApiService from '../services/ApiService.js';
import { useUserSelectedBranchLocation } from '../hooks/useUserSelectedBranchLocation.js';
import { useDispatch } from 'react-redux';
import { useUserProfile } from '../hooks/useUserProfile.js';
import { useUserClinic } from '../hooks/useUserClinic.js';
import FAQDrawer from './FAQDrawer';
import { Button } from 'antd';
import { useUserToken } from '../hooks/useToken.js';
import { useOnboardingTour } from '../hooks/useOnboardingTour.js';
import { USER_IS_FIRST_LOGIN } from '../axios/constants.js';
import { clearAll } from '../utils/local-storage.js';
const Header = () => {
  const { unSetUserToken } = useUserToken();
  const dispatch = useDispatch();
  const [isFAQOpen, setIsFAQOpen] = useState(false);
  const { selectedLocation } = useUserSelectedBranchLocation();
  const { userClinic } = useUserClinic();
  const { userProfile } = useUserProfile();
  const { shouldStartTour } = useOnboardingTour();

  useEffect(() => {
    // Check if user just logged in and should see the tour
    const checkFirstLogin = () => {
      const isFirstLogin = localStorage.getItem(USER_IS_FIRST_LOGIN);
      if (isFirstLogin === null && userProfile?.fullName) {
        localStorage.setItem(USER_IS_FIRST_LOGIN, 'true');
      }
    };

    if (userProfile?.fullName) {
      checkFirstLogin();
    }
  }, [userProfile]);

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle('slide-nav');
    document.getElementsByTagName('html')[0].classList.toggle('menu-opened');
    document.getElementsByClassName('sidebar-overlay')[0].classList.toggle('opened');
  };

  const logOut = async () => {
    await ApiService.AuthLogout().then(() => {
      clearAll();
      dispatch({ type: 'RESET' });
      unSetUserToken();
    });
  };

  return (
    <div className="main-wrapper">
      <div className="header">
        <div className="header-left">
          <Link to="/user/admin-dashboard" className="logo">
            <img src={logoVoxel} alt="#" style={{ height: 80 }} />
          </Link>
        </div>

        <Link
          id="mobile_btn"
          className="mobile_btn float-start"
          to="#"
          onClick={handlesidebarmobilemenu}
        >
          <img src={baricon1} alt="" />
        </Link>

        <ul className="nav user-menu float-end">
          <li style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginRight: '20px' }}>
            <Button
              // type='text'
              onClick={() => setIsFAQOpen(true)}
            >
              FAQs ?
            </Button>
          </li>
          <li
            id="account-profile"
            className="nav-item dropdown has-arrow user-profile-list"
          >
            <span
              style={{ marginTop: 15 }}
              className="dropdown-toggle nav-link user-link"
              data-bs-toggle="dropdown"
            >
              <div className="user-names">
                <h5>{userProfile?.fullName} </h5>
                <div className="d-flex flex-column text-left">
                  <span className="text-uppercase">
                    {selectedLocation?.title}
                  </span>
                  <span className="text-uppercase">
                    Clinic ID: {userClinic?.clinicId}
                  </span>
                </div>
              </div>
              <span className="user-img">
                <img src={userProfile?.profileImageUrl || user06} alt="Admin" />
              </span>
            </span>
            <div className="dropdown-menu">
              <Link className="dropdown-item" to="/user/profile">
                My Profile
              </Link>
              {/* <Link className="dropdown-item" to="/user/edit-profile">
                Edit Profile
              </Link> */}
              <Link className="dropdown-item" to="/select-branch-location">
                Select Clinic Location
              </Link>
              <Link id="settings-link" className="dropdown-item" to="/user/settings">
                 Payment Settings
              </Link>
              {/* <Link className="dropdown-item" to="/profile">My Profile</Link> */}
              <a
                href="/"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  logOut();
                }}
              >
                Logout
              </a>
            </div>
          </li>
          <li className="nav-item ">
            {/* <Link to="/settings" className="hasnotifications nav-link">
              <img src={settingicon01} alt="" />{" "}
            </Link> */}
          </li>
        </ul>
        <div className="dropdown mobile-user-menu">
          <a
            href="/"
            className="nav-link dropdown-toggle"
            role="button"
            aria-haspopup="true"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={(event) => event.preventDefault()}
          >
            <i className="fa fa-ellipsis-v" />
          </a>
          <div className="dropdown-menu dropdown-menu-end">
            <Link className="dropdown-item" to="/user/profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="/select-branch-location">
              Select Clinic Location
            </Link>
            <Link className="dropdown-item" to="/user/settings">
              Payment Settings
            </Link>
            <a
              href="/"
              className="dropdown-item"
              onClick={(event) => {
                event.preventDefault();
                logOut();
              }}
            >
              Logout
            </a>
          </div>
        </div>

        <FAQDrawer isOpen={isFAQOpen} onClose={() => setIsFAQOpen(false)} />
      </div>
    </div>
  );
};

export default Header;